export const THREE_PI_PROPERTY_CATEGORIES = {
  APARTMENT: {
    transcode: 't_PROPERTYTYPEAPARTMENT',
    theme: 'blue-lightest',
  },
  APARTHOTEL: {
    transcode: 't_PROPERTYTYPEAPARTHOTEL',
    theme: 'blue-lightest',
  },
  CAMPSITE: {
    transcode: 't_PROPERTYTYPECAMPSITE',
    theme: 'green-lightest',
  },
  COUNTRYHOUSE: {
    transcode: 't_PROPERTYTYPECOUNTRYHOUSE',
    theme: 'green-lightest',
  },
  GUESTHOUSE: {
    transcode: 't_PROPERTYTYPEGUESTHOUSE',
    theme: 'green-lightest',
  },
  HOLIDAYHOME: {
    transcode: 't_PROPERTYTYPEHOLIDAYHOME',
    theme: 'green-lightest',
  },
  HOLIDAYPARK: { transcode: 't_PROPERTYTYPEHOLIDAYPARK' },
  HOMESTAY: {
    transcode: 't_PROPERTYTYPEHOMESTAY',
    theme: 'green-lightest',
  },
  HOSTEL: {
    transcode: 't_PROPERTYTYPEHOSTEL',
    theme: 'orange-lightest',
  },
  HOTEL: {
    transcode: 't_PROPERTYTYPEHOTEL',
    theme: 'blue-lightest',
  },
  INN: {
    transcode: 't_PROPERTYTYPEINN',
    theme: 'blue-lightest',
  },
  LODGE: {
    transcode: 't_PROPERTYTYPELODGE',
    theme: 'green-lightest',
  },
  LOVEHOTEL: {
    transcode: 't_PROPERTYTYPELOVEHOTEL',
    theme: 'blue-lightest',
  },
  MOTEL: {
    transcode: 't_PROPERTYTYPEMOTEL',
    theme: 'blue-lightest',
  },
  OTHER: { transcode: 't_OTHER' },
  RESIDENCE: { transcode: 't_PROPERTYTYPERESIDENCE' },
  RESORT: {
    transcode: 't_PROPERTYTYPERESORT',
    theme: 'blue-lightest',
  },
  RYOKAN: {
    transcode: 't_PROPERTYTYPERYOKAN',
    theme: 'blue-lightest',
  },
};
